<template>
  <avs-deleteDialog
    v-model="value"
    @cancel="handleCancel"
    @delete="rmdir"
    noPrevention
    resource="folder"
  />
</template>

<script>
import DocumentationService from "@/services/DocumentationService"

export default {
  name: "DialogDeleteFolder",
  props: {
    folder: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    message() {
      return this.$t("messages.information.delete_entity", {
        type: this.$tc("commons.folder", 1).toLowerCase(),
        entity: this.folder.name
      })
    },
    projectId() {
      return this.$store.state.app.project.id
    }
  },
  methods: {
    rmdir() {
      DocumentationService.deleteFolder(this, this.projectId, this.folder.id).then(response => {
        this.$store.commit("app/message", {
          msg: this.$t("messages.success.deleted", { entity: this.$tc("commons.folder", 1) }),
          color: "success"
        })
        this.$emit("close", true)
      })
    },
    handleCancel() {
      this.$emit("close", true)
    }
  }
}
</script>
